import phoneIconSrc from '@corbado/shared-ui/assets/phone.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const PhoneIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, phoneIconSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'phone-icon', ...props }));
});
